import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MainFacade } from 'src/app/pages/main.facade';

@Component({
  selector: 'app-shareprofile',
  templateUrl: './shareprofile.component.html',
  styleUrls: ['./shareprofile.component.scss']
})
export class ShareprofileComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  public user$: Observable<any>|undefined;
  public nfts$: Observable<any>|undefined;
  public user:any;
  public nfts:any[];
  constructor(private mainfacade:MainFacade) { }

  ngOnInit(): void {
    this.createSubscriptions();
    
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }

  drawCanvas(){
    var ctx = (<HTMLCanvasElement>document.getElementById('canvas')).getContext('2d');
    
    let layers = [{place:{x:0,y:0}, src:'../../../assets/img/Laptop.png', size:{w:500,h:500}},{place:{x:36,y:88}, src:this.user.ImageUrl, size:{w:68,h:68}}]
    let r = 0;
    let c = 0;
    this.nfts.forEach((val)=>{

      if(val.Image && r<6){
        layers.push({place:{x:185+(c*32),y:80+(r*32)}, src:val.Image, size:{w:30,h:30}});
        if(c==5){
          c = 0;
          r++;
        }
        else{
          c++;
        }
      }
      
    })
    console.log(layers)
    Promise
      .all(layers.map(i => this.drawNftIn(i.src,i.place, i.size)))
      .then((newImages) => {
  
        for(var y = 0; newImages.length > y;y++){

          var place = newImages[y]['place'];
          var newImage = newImages[y]['image'];
          var size = newImages[y]['size']
          
          ctx.drawImage(newImage, place.x, place.y, size.w, size.h);
          
        }
        ctx.font = "10px Arial";
        ctx.fillStyle = "#E54242";
        ctx.fillText(this.user?.UserName, 205, 310);  
        


        
      }).catch(error=>{
        console.log(error)
      }).finally(()=>{

        var canvas = (<HTMLCanvasElement>document.getElementById('canvas'));
        var ctx = canvas.getContext('2d');
        

      })







    
    
  }

  async drawNftIn(src, place, size) {
    console.log('Draw')
    var newImage = new Image();
    newImage.crossOrigin = "anonymous";
    newImage.src=src;
    /*if(src.indexOf('../../../')>-1){

      newImage.src=src;
    }
    else{
      let base=null;
      try {
        let data= await fetch('https://roomzshow.xyz/api/image/'+encodeURIComponent(src));     
        console.log(data)
        base = await data.text();

      }
      catch(err){
        console.log(err)
      }
      
      
      newImage.src = 'data:image/png;base64,'+base;
    
    }*/
    
      //newImage.src = src+"?not-from-cache-please";
    return new Promise((resolve, reject) => {
      newImage.onload = () => {
        
        resolve({
          image: newImage, place: place, size:size
        });
      }
      newImage.onerror = () =>{
        console.log('error')
        //this.toastr.error('Image could not be loaded into the canvas.')
        resolve({
          image: '', place: 0, src:''
        });
      }
      
    });

  }

  createSubscriptions(){
    this.user$ = this.mainfacade.user$;
    this.nfts$ = this.mainfacade.nfts$;
    this.user$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
  
        if(message){
          this.user = message;
       
        }
    });

    this.nfts$
    .pipe(takeUntil(this.destroy$))
    .subscribe((message)=>{ 
  
        if(message){
          this.nfts = message;
          
          this.drawCanvas();
        }
    });
  }

  close(){
    this.mainfacade.getShareprofile(false);
  }

  export(){
    var download = (<HTMLLinkElement>document.getElementById("download"));
    var ctx = (<HTMLCanvasElement>document.getElementById("canvas"));
    var image = ctx.toDataURL('image/png').replace("image/png", "image/octet-stream");
    download.crossOrigin = "anonymous";
    download.setAttribute("href", image);
    
    

  
  }

}
